import { BUSINESS_CENTER_CATEGORIES } from '../../constants/categories';
import { IOfferState } from '../../types/reducers/offer';

/**
 *
 * @description Проверяет, выбрана ли категория "Аренда офиса в бизнес-центре".
 */
export function checkBusinessCenterCategory(offer: IOfferState): boolean {
  const { category, coworkingOfferType } = offer;

  if (category === 'officeRent' && coworkingOfferType) {
    return false;
  }

  return BUSINESS_CENTER_CATEGORIES.includes(category as string);
}
